import { render, staticRenderFns } from "./grupo.vue?vue&type=template&id=68bb4d90&"
import script from "./grupo.vue?vue&type=script&lang=js&"
export * from "./grupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports